import { atom } from 'jotai';
import { $SharingEnterTraffic } from './traffic';

export const $FetchSearchParam = atom((get) => {
  const { sharePlatform, sharerToken, isSharingTest } = get($SharingEnterTraffic);
  const res: Record<string, string> = {
    _r: '1',
    _t: sharerToken,
    share_platform: sharePlatform,
  };

  if (isSharingTest) {
    res['sharing_test'] = '1';
  }

  return res;
});
